  <div class="row">
  <div class="col-lg-1 col-12">
    <app-uiform-side-menu
      [uiformId]="uiformId"
      targetId="pivot"
      [usecaseId]="usecaseId"
      [appId]="appId"
    >
    </app-uiform-side-menu>
    </div>

  <div class="col-lg-11 col-12 ps-lg-0 my-margin-left" #content>
    <div class="row">
      <div class="col-12">
        <div class="breadcrumb-title border-0 mb-3">
          <div
            class="d-flex justify-content-start align-items-center gap-2 flex-wrap"
          >
            <mat-icon color="primary">pie_chart</mat-icon>
            <p class="text-break text-wrap mb-0">
              {{ form.data["title"] }} {{ "customReport.title" | translate }}
            </p>
            <mat-icon
              class="cursor-pointer ms-1"
              color="primary"
              [matTooltip]="'customReport.buttons.downloadPDF' | translate"
              matTooltipPosition="right"
              (click)="exportPDFData()"
            >
              picture_as_pdf
            </mat-icon>
  </div>
    </div>
          </div>

      <div class="col-12">
        <div class="card">
          <div class="card-body compact-inputs dropdown-pd-none">
            <div>
              <button
                mat-stroked-button
                color="primary"
                (click)="toggleSearchInputs()"
                [title]="'customReport.filter.tooltips.filter' | translate"
              >
                <mat-icon>tune</mat-icon>
                <span>{{ "customReport.filter.title" | translate }}</span>
                        </button>
            </div>

            <div *ngIf="showSearchInputs" class="pb-0 mt-3">
              <div class="container-fluid p-0">
                <div class="row g-2">
                  <!-- Field Selection -->
                  <div class="col-lg-auto col-md-6 col-12">
                    <div class="d-flex align-items-center">
                      <!-- <mat-form-field
                        appearance="outline"
                        class="w-100"
                        subscriptSizing="dynamic"
                      >
                        <mat-select
                          [(ngModel)]="searchData['field']"
                          name="field"
                          [placeholder]="
                            'customReport.filter.placeholders.selectField'
                              | translate
                          "
                          (ngModelChange)="onConditionChange()"
                        >
                          <mat-option
                            *ngFor="let e of filterAttributes"
                            [value]="e['code']"
                            (click)="selectSearch(e, 'field')"
                          >
                            <div class="d-flex align-items-center gap-2 py-1">
                              <span
                                class="badge"
                                [ngClass]="getButtonClass(e['type'])"
                              >
                                {{ getButtonLabels(e["type"]) }}
                              </span>
                              <span
                                [matTooltip]="e['label']"
                                class="text-truncate"
                              >
                                {{ e["label"] }}
                              </span>
                      </div>
                          </mat-option>
                        </mat-select>
                      </mat-form-field> -->
                      <mat-form-field
                        appearance="outline"
                        class="w-100"
                        subscriptSizing="dynamic"
                      >
                        <mat-select
                          [(ngModel)]="searchData['field']"
                          name="field"
                          [placeholder]="
                            'customReport.filter.placeholders.selectField'
                              | translate
                          "
                          (ngModelChange)="onConditionChange()"
                        >
                          <!-- ✅ Safe trigger (NO arrow, NO regex) -->
                          <mat-select-trigger>
                            {{ searchData["field"]?.replace("D ", "") }}
                          </mat-select-trigger>

                          <!-- ✅ Options -->
                          <mat-option
                            *ngFor="let e of filterAttributes"
                            [value]="e['code']"
                            (click)="selectSearch(e, 'field')"
                          >
                            <div class="d-flex align-items-center gap-2 py-1">
                              <span
                                class="badge"
                                [ngClass]="getButtonClass(e['type'])"
                              >
                                {{ getButtonLabels(e["type"]) }}
                              </span>

                              <span
                                [matTooltip]="e['label']"
                                class="text-truncate"
                              >
                                {{ e["label"] }}
                      </span>
                    </div>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-icon
                        class="icon-compact text-secondary"
                        [matTooltip]="
                          'customReport.filter.tooltips.field' | translate
                        "
                        matTooltipPosition="above"
                        >info</mat-icon
                      >
                </div>
              </div>

                  <!-- Condition Selection -->
                  <div class="col-lg-auto col-md-6 col-12">
                    <div class="d-flex align-items-center">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-select
                      [(ngModel)]="searchData['condition']"
                       (ngModelChange)="onConditionChange()"
                          name="condition"
                          [placeholder]="
                            'customReport.filter.placeholders.selectCondition'
                              | translate
                          "
                        >
                          <mat-option
                            *ngFor="let e of operators"
                            [value]="e.value"
                          >
                            {{ e.label }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-icon
                        class="text-secondary icon-compact"
                        [matTooltip]="
                          'customReport.filter.tooltips.condition' | translate
                        "
                        matTooltipPosition="above"
                        >info</mat-icon
                      >
                </div>
              </div>

                  <!-- Value Input Section -->
                  <div class="col-lg-auto col-md-12">
                    <div
                      class="d-flex align-items-center flex-wrap flex-sm-nowrap gap-1"
                    >
                      <div class="d-flex flex-sm-nowrap align-items-center">
                        <ng-container
                          *ngIf="
                            !['NULL', 'NOT NULL', 'EMPTY'].includes(
                              searchData['condition']
                            )
                          "
                        >
                    <!-- Custom Day Dropdown -->
                          <div
                            class="custom-dropdown-wrapper flex-shrink-0"
                            *ngIf="
                              searchData['condition'] === 'DAY' &&
                              selectedSearchAtt === 'date'
                            "
                            style="min-width: 90px"
                          >
                            <div
                              class="custom-dropdown"
                              (click)="
                                toggleDayDropdown(); $event.stopPropagation()
                              "
                            >
                              <span>{{ selectedDay || "Select Day" }}</span>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                      <ul *ngIf="dayDropdownOpen" class="dropdown-list">
                              <li
                                *ngFor="let day of days; let i = index"
                           [class.sticky-first-item]="i === 0"
                                (click)="
                                  selectDay(day); $event.stopPropagation()
                                "
                              >
                          {{ day }}
                                <div
                                  *ngIf="i === 0"
                                  class="dropdown-separator"
                                ></div>
                        </li>
                      </ul>
                    </div>

                    <!-- Custom Month Dropdown -->
                          <div
                            class="custom-dropdown-wrapper flex-shrink-0"
                            *ngIf="
                              searchData['condition'] === 'MONTH' &&
                              selectedSearchAtt === 'date'
                            "
                            style="min-width: 90px"
                          >
                            <div
                              class="custom-dropdown"
                              (click)="
                                toggleMonthDropdown(); $event.stopPropagation()
                              "
                            >
                              <span>{{
                                getMonthName(selectedMonth) || "Select Month"
                              }}</span>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                      <ul *ngIf="monthDropdownOpen" class="dropdown-list">
                              <li
                                *ngFor="let month of months; let i = index"
                        [class.sticky-first-item]="i === 0"
                                (click)="
                                  selectMonth(month); $event.stopPropagation()
                                "
                              >
                          {{ month.name }}
                                <div
                                  *ngIf="i === 0"
                                  class="dropdown-separator"
                                ></div>
                        </li>
                      </ul>
                    </div>

                    <!-- Day + Month Combined -->
                          <div
                            *ngIf="
                              searchData['condition'] === 'DAY_AND_MONTH' &&
                              selectedSearchAtt === 'date'
                            "
                            class="d-flex gap-1 flex-shrink-0"
                          >
                            <div
                              class="custom-dropdown-wrapper"
                              style="min-width: 70px"
                            >
                              <div
                                class="custom-dropdown custom-dropdown_dm"
                                (click)="
                                  toggleDayDropdown(); $event.stopPropagation()
                                "
                              >
                                <span>{{ selectedDay || "D" }}</span>
                          <i class="fa fa-chevron-down"></i>
                        </div>
                        <ul *ngIf="dayDropdownOpen" class="dropdown-list">
                                <li
                                  *ngFor="let day of days; let i = index"
                             [class.sticky-first-item]="i === 0"
                                  (click)="
                                    selectDayForDayMonth(day);
                                    $event.stopPropagation()
                                  "
                                >
                            {{ day }}
                                  <div
                                    *ngIf="i === 0"
                                    class="dropdown-separator"
                                  ></div>
                          </li>
                        </ul>
                      </div>
                            <div
                              class="custom-dropdown-wrapper"
                              style="min-width: 70px"
                            >
                              <div
                                class="custom-dropdown custom-dropdown_dm"
                                (click)="
                                  toggleMonthDropdown();
                                  $event.stopPropagation()
                                "
                              >
                                <span>{{
                                  getMonthName(selectedMonth) || "M"
                                }}</span>
                          <i class="fa fa-chevron-down"></i>
                        </div>
                              <ul
                                *ngIf="monthDropdownOpen"
                                class="dropdown-list"
                              >
                                <li
                                  *ngFor="let month of months; let i = index"
                          [class.sticky-first-item]="i === 0"
                                  (click)="
                                    selectMonthForDayMonth(month);
                                    $event.stopPropagation()
                                  "
                                >
                            {{ month.name }}
                                  <div
                                    *ngIf="i === 0"
                                    class="dropdown-separator"
                                  ></div>
                          </li>
                        </ul>
                      </div>
                    </div>

                          <!-- Regular Inputs (Text, Number, Date) -->
                          <ng-container
                            *ngIf="searchData['condition'] !== 'BETWEEN'"
                          >
                            <!-- Text Input -->
                            <mat-form-field
                              *ngIf="
                                selectedSearchAtt != 'number' &&
                                selectedSearchAtt != 'expression' &&
                                selectedSearchAtt != 'long' &&
                                selectedSearchAtt != 'date'
                              "
                              appearance="outline"
                              class="flex-grow-1"
                              subscriptSizing="dynamic"
                              style="min-width: 120px"
                            >
                              <input
                                matInput
                                [(ngModel)]="searchData['value']"
                                placeholder="{{
                                  'Remains.Enter_New' | translate
                                }}"
                                type="text"
                              />
                            </mat-form-field>

                            <!-- Number Input -->
                            <mat-form-field
                              *ngIf="
                                selectedSearchAtt === 'number' ||
                                selectedSearchAtt === 'expression' ||
                                selectedSearchAtt === 'long'
                              "
                              appearance="outline"
                              class="flex-grow-1"
                              subscriptSizing="dynamic"
                              style="min-width: 120px"
                            >
                              <input
                                matInput
                                [(ngModel)]="searchData['value']"
                                placeholder="Enter search value"
                                type="number"
                              />
                            </mat-form-field>

                            <!-- Date Input -->
                            <mat-form-field
                              appearance="outline"
                              class="w-100"
                              *ngIf="
                                selectedSearchAtt === 'date' &&
                                searchData['condition'] != 'DAY' &&
                                searchData['condition'] != 'MONTH' &&
                                searchData['condition'] != 'DAY_AND_MONTH'
                              "
                            >
                              <input
                                matInput
                                type="date"
                                #dateInput
                                [(ngModel)]="searchData['value']"
                              />
                              <button
                                mat-icon-button
                                matSuffix
                                type="button"
                                class="icon-pd-none"
                                (click)="dateInput.showPicker()"
                                aria-label="Open date picker"
                              >
                                <mat-icon class="icon-compact text-secondary"
                                  >event</mat-icon
                                >
                              </button>
                            </mat-form-field>
                          </ng-container>

                          <!-- BETWEEN Range -->
                          <ng-container
                            *ngIf="searchData['condition'] === 'BETWEEN'"
                          >
                            <div
                              class="d-flex flex-nowrap align-items-center"
                              style="flex: 1"
                            >
                              <!-- Text Range -->
                              <ng-container
                                *ngIf="selectedSearchAtt === 'text'"
                              >
                                <mat-form-field
                                  appearance="outline"
                                  subscriptSizing="dynamic"
                                  style="width: 180px"
                                >
                                  <input
                                    matInput
                                    [(ngModel)]="searchData['rangeFrom']"
                                    placeholder="Enter From value"
                                    type="text"
                                  />
                                </mat-form-field>
                                <mat-form-field
                                  appearance="outline"
                                  subscriptSizing="dynamic"
                                  style="width: 180px"
                                >
                                  <input
                                    matInput
                                    [(ngModel)]="searchData['rangeTo']"
                                    placeholder="Enter To value"
                                    type="text"
                                  />
                                </mat-form-field>
                              </ng-container>

                              <!-- Number Range -->
                              <ng-container
                                *ngIf="
                                  selectedSearchAtt === 'number' ||
                                  selectedSearchAtt === 'expression' ||
                                  selectedSearchAtt === 'long'
                                "
                              >
                                <mat-form-field
                                  appearance="outline"
                                  subscriptSizing="dynamic"
                                  style="width: 180px"
                                >
                  <input
                                    matInput
                                    [(ngModel)]="searchData['rangeFrom']"
                                    placeholder="Enter From value"
                                    type="number"
                                  />
                                </mat-form-field>
                                <mat-form-field
                                  appearance="outline"
                                  subscriptSizing="dynamic"
                                  style="width: 180px"
                                >
                                  <input
                                    matInput
                                    [(ngModel)]="searchData['rangeTo']"
                                    placeholder="Enter To value"
                                    type="number"
                                  />
                                </mat-form-field>
                              </ng-container>

                              <!-- Date Range -->
                  <input
                                *ngIf="selectedSearchAtt === 'date'"
                                type="text"
                                class="form-control form-control-sm"
                                ngxDaterangepickerMd
                                [(ngModel)]="searchData['rangeDate']"
                                [showCustomRangeLabel]="true"
                                [alwaysShowCalendars]="true"
                                [ranges]="ranges"
                                [showDropdowns]="true"
                                [linkedCalendars]="true"
                                placeholder="Select please..."
                                style="width: 180px"
                              />
                            </div>
                          </ng-container>

                          <!-- Tooltip Icon -->
                          <mat-icon
                            *ngIf="selectedSearchAtt"
                            class="icon-compact text-secondary"
                            [matTooltip]="'TOOLTIPS.FILTER_VALUE' | translate"
                            matTooltipPosition="above"
                            >info</mat-icon
                          >
                </ng-container>
                      </div>

                      <!-- Add Button -->
                      <button
                        mat-stroked-button
                        color="primary"
                        class="flex-shrink-0"
                        [disabled]="
                          !searchData['value'] &&
                          !searchData['condition'] &&
                          !searchData['field']
                        "
                        (click)="addSearchData()"
                      >
                        <mat-icon>add</mat-icon>
                        {{ "COMMON.ADD" | translate }}
                </button>
              </div>
            </div>
                </div>

                <!-- Applied Filters -->
                <div class="row mt-2">
                  <div class="col-12">
                    <div class="d-flex flex-wrap align-items-center gap-1">
                      <button
                        *ngFor="let e of searchViewList; let i = index"
                        (click)="removeSearchData(i)"
                        type="button"
                        class="btn btn-outline-secondary btn-sm m-1 p-1 d-inline-flex align-items-center"
                      >
                <ng-container [ngSwitch]="e.condition">
                    <span *ngSwitchCase="'Day'">
                            {{ e.field }} {{ e.condition }} :
                            {{ e.value?.split("-")[2] }}
                    </span>
                    <span *ngSwitchCase="'Month'">
                            {{ e.field }} {{ e.condition }} :
                            {{ e.value?.split("-")[1] }}
                    </span>
                    <span *ngSwitchCase="'Day & Month'">
                            {{ e.field }} Day:
                            {{ e.value?.split("-")[2] }} Month:
                            {{ e.value?.split("-")[1] }}
                    </span>
                    <span *ngSwitchDefault>
                            {{ e.field }} {{ e.condition }} {{ e.value }}
                            {{ e.rangeFrom }} {{ e.rangeTo }}
                    </span>
             </ng-container>
              <i class="fa fa-times ms-1 fs-6"></i>
            </button>
                    </div>
                  </div>
                </div>

                <!-- Filter Action Buttons -->
                <div class="row mt-2">
                  <div class="col-12">
                    <div class="d-flex align-items-center gap-2">
                      <button
                        mat-stroked-button
                        color="primary"
                        (click)="searchAndDraw(true)"
                      >
                        <mat-icon class="me-1">search</mat-icon>
                        {{ "customReport.buttons.search" | translate }}
              </button>
                      <button
                        mat-stroked-button
                        color="primary"
                        (click)="resetSearchCriteria()"
                      >
                        <i class="fa fa-eraser"></i>
                        <span class="ms-2">{{
                          "customReport.buttons.reset" | translate
                        }}</span>
              </button>
            </div>
          </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body pt-0">
            <div
              class="d-flex align-items-center justify-content-between border-bottom pb-2 mt-2"
            >
              <div
                class="d-flex align-items-center gap-2 cursor-pointer"
                (click)="toggleInputs()"
              >
                <mat-icon color="primary" class="fs-4">assessment</mat-icon>
                <h6 class="mb-0 fw-semibold">
                  {{ "customReport.createReport.title" | translate }}
                </h6>
              </div>
              <span
                data-bs-toggle="modal"
                data-bs-target="#info"
                class="cursor-pointer"
              >
                <i class="bi bi-info-circle fs-5 text-secondary"></i>
            </span>
          </div>

            <form
              class="px-3 py-3 mb-2 compact-inputs dropdown-pd-none"
              #chartForm="ngForm"
              *ngIf="showFilterInputs"
            >
            <div class="pdf-exclude">
                <!-- I Want Section -->
                <div class="row g-2 align-items-start mb-3">
                  <div class="col-12">
                    <div class="row align-items-center">
                      <div
                        class="col-xl-2 col-lg-3 col-md-4 col-12 mb-md-0 mb-2"
                      >
                        <label
                          for="SelectValues"
                          class="fw-medium mb-0 text-wrap"
                        >
                          <!-- {{
                            "customReport.createReport.iWant.label" | translate
                          }} -->
                          Select Aggregation for Y-Axis :
                      </label>
                      </div>
                      <div class="col-xl-10 col-lg-9 col-md-8 col-12">
                        <div class="row g-2">
                          <div class="col-12 col-sm-auto">
                            <mat-form-field
                              appearance="outline"
                              class="no-bottom-margin w-100"
                            >
                              <mat-select
                                [(value)]="pivotform['values']"
                                [placeholder]="
                                  'customReport.createReport.iWant.select'
                                    | translate
                                "
                              >
                                <mat-select-trigger>{{
                                  pivotform["values"]
                                }}</mat-select-trigger>
                                <mat-option
                                  *ngFor="let e of filterAttributes"
                                  [value]="e['label']"
                                  (click)="selectColumn(e['label'], 'values')"
                                >
                                  <div class="d-flex align-items-center gap-2">
                                    <span
                                      class="badge fw-light iconSize"
                                      [ngClass]="getButtonClass(e['type'])"
                                    >
                                      {{ getButtonLabels(e["type"]) }}
                            </span>
                                    <span
                                      [title]="e['label']"
                                      class="text-truncate"
                                      >{{ e["label"] }}</span
                                    >
                        </div>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                        </div>
                          <!-- Aggregation type -->
                          <div class="col-12 col-sm-auto">
                            <mat-form-field
                              appearance="outline"
                              class="no-bottom-margin w-100"
                            >
                              <mat-select
                                [(ngModel)]="pivotform['aggfunc']"
                                name="aggType"
                                #aggType1
                              >
                                <mat-option value="sum">{{
                                  "customReport.createReport.iWant.aggOptions.sum"
                                    | translate
                                }}</mat-option>
                                <mat-option value="mean">{{
                                  "customReport.createReport.iWant.aggOptions.mean"
                                    | translate
                                }}</mat-option>
                                <mat-option value="count">{{
                                  "customReport.createReport.iWant.aggOptions.count"
                                    | translate
                                }}</mat-option>
                                <mat-option value="min">{{
                                  "customReport.createReport.iWant.aggOptions.min"
                                    | translate
                                }}</mat-option>
                                <mat-option value="max">{{
                                  "customReport.createReport.iWant.aggOptions.max"
                                    | translate
                                }}</mat-option>
                                <mat-option value="std">{{
                                  "customReport.createReport.iWant.aggOptions.std"
                                    | translate
                                }}</mat-option>
                                <mat-option value="median">{{
                                  "customReport.createReport.iWant.aggOptions.median"
                                    | translate
                                }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-12 col-sm-auto">
                            <div class="row g-2">
                              <div class="col-6 col-sm-auto">
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  class="w-100"
                                  [disabled]="
                                    !pivotform['aggfunc'] ||
                                    !pivotform['values']
                                  "
                                  (click)="
                                    updateFormField(
                                      'aggfunc',
                                      pivotform['values'],
                                      aggType1.value,
                                      true
                                    )
                                  "
                                >
                                  <mat-icon>add</mat-icon>
                                  {{ "COMMON.ADD" | translate }}
                          </button>
                        </div>
                              <div
                                class="col-6 col-sm-auto d-flex align-items-center"
                              >
                                <span
                                  [title]="
                                    'customReport.createReport.iWant.tooltip'
                                      | translate
                                  "
                                  class="d-flex align-items-center"
                                >
                                  <mat-icon class="icon-compact text-secondary"
                                    >info</mat-icon
                                  >
                        </span>
                      </div>
                    </div>
                  </div>
                        </div>
                      </div>
                      <!-- Chips -->
                      <div
                        class="col-12 mt-2"
                        *ngIf="
                          reqform?.['aggfunc'] &&
                          objectEntries(reqform['aggfunc']).length
                        "
                      >
                        <div class="d-flex flex-wrap gap-1">
                          <button
                            *ngFor="
                              let entry of objectEntries(reqform['aggfunc'])
                            "
                            (click)="removeFormField('aggfunc', entry[0], true)"
                            type="button"
                            class="btn btn-outline-secondary btn-sm me-1 mb-1 p-1"
                          >
                        {{ entry[0] }} ({{ entry[1] }})
                        <i class="fa fa-times ms-1 fs-6"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
                </div>

                <!-- Category By Section -->
                <div class="row g-2 align-items-start mb-3">
                  <div class="col-12">
                    <div class="row align-items-center">
                      <div
                        class="col-xl-2 col-lg-3 col-md-4 col-12 mb-md-0 mb-2"
                      >
                        <label class="fw-medium mb-0 text-nowrap">
                          <!-- {{
                            "customReport.createReport.categoryBy.label"
                              | translate
                          }} -->
                          Group by :
                      </label>
                      </div>
                      <div class="col-xl-10 col-lg-9 col-md-8 col-12">
                        <div class="row g-2">
                          <div class="col-12 col-sm-auto">
                            <mat-form-field
                              appearance="outline"
                              class="no-bottom-margin w-100"
                            >
                              <mat-select
                                [(value)]="pivotform['columns']"
                                [placeholder]="
                                  'customReport.createReport.categoryBy.select'
                                    | translate
                                "
                              >
                                <mat-select-trigger>{{
                                  pivotform["columns"]
                                }}</mat-select-trigger>
                                <mat-option
                                  *ngFor="let e of filterRowColumns()"
                                  [value]="e['label']"
                                  (click)="selectColumn(e['label'], 'columns')"
                                >
                                  <div class="d-flex align-items-center gap-2">
                                    <span
                                      class="badge fw-light iconSize"
                                      [ngClass]="getButtonClass(e['type'])"
                                    >
                                      {{ getButtonLabels(e["type"]) }}
                            </span>
                                    <span
                                      [title]="e['label']"
                                      class="text-truncate"
                                      >{{ e["label"] }}</span
                                    >
                                  </div>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-12 col-sm-auto">
                            <div class="row g-2">
                              <div class="col-6 col-sm-auto">
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  class="w-100"
                                  [disabled]="!pivotform['columns']"
                                  (click)="
                                    updateFormField(
                                      'columns',
                                      pivotform['columns']
                                    )
                                  "
                                >
                                  <mat-icon>add</mat-icon>
                                  {{ "COMMON.ADD" | translate }}
                          </button>
                        </div>
                              <div
                                class="col-6 col-sm-auto d-flex align-items-center"
                              >
                                <span
                                  [title]="
                                    'customReport.createReport.categoryBy.tooltip'
                                      | translate
                                  "
                                  class="d-flex align-items-center text-secondary"
                                >
                                  <mat-icon class="icon-compact">info</mat-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                        </div>
                      </div>
                      <!-- Chips -->
                      <div
                        class="col-12 mt-2"
                        *ngIf="reqform['columns']?.length > 0"
                      >
                        <div class="d-flex flex-wrap gap-1">
                          <button
                            *ngFor="let e of reqform['columns']"
                            (click)="removeFormField('columns', e)"
                            type="button"
                            class="btn btn-outline-secondary btn-sm me-1 mb-1"
                          >
                      {{ e }}
                      <i class="fa fa-times ms-1 fs-6"></i>
                    </button>
                  </div>
                </div>
              </div>
                  </div>
                </div>

                <!-- Group By Section -->
                <div class="row g-2 align-items-start mb-3">
                  <div class="col-12">
                    <div class="row align-items-center">
                      <div
                        class="col-xl-2 col-lg-3 col-md-4 col-12 mb-md-0 mb-2"
                      >
                        <label class="fw-medium mb-0 text-nowrap">
                          <!-- {{
                            "customReport.createReport.groupBy.label"
                              | translate
                          }} -->
                          X-Axis :
                      </label>
                      </div>
                      <div class="col-xl-10 col-lg-9 col-md-8 col-12">
                        <div class="row g-2">
                          <div class="col-12 col-sm-auto">
                            <mat-form-field
                              appearance="outline"
                              class="no-bottom-margin w-100"
                            >
                              <mat-select
                                [(value)]="pivotform['index']"
                                [placeholder]="
                                  'customReport.createReport.groupBy.select'
                                    | translate
                                "
                              >
                                <mat-select-trigger>{{
                                  pivotform["index"]
                                }}</mat-select-trigger>
                                <mat-option
                                  *ngFor="let e of filterRowColumns()"
                                  [value]="e['label']"
                                  (click)="selectColumn(e['label'], 'index')"
                                >
                                  <div class="d-flex align-items-center gap-2">
                                    <span
                                      class="badge fw-light iconSize"
                                      [ngClass]="getButtonClass(e['type'])"
                                    >
                                      {{ getButtonLabels(e["type"]) }}
                            </span>
                                    <span
                                      [title]="e['label']"
                                      class="text-truncate"
                                      >{{ e["label"] }}</span
                                    >
                                  </div>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-12 col-sm-auto">
                            <div class="row g-2">
                              <div class="col-6 col-sm-auto">
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  class="w-100"
                                  [disabled]="!pivotform['index']"
                                  (click)="
                                    updateFormField('index', pivotform['index'])
                                  "
                                >
                                  <mat-icon>add</mat-icon>
                                  {{ "COMMON.ADD" | translate }}
                          </button>
                        </div>
                              <div
                                class="col-6 col-sm-auto d-flex align-items-center"
                              >
                                <span
                                  [title]="
                                    'customReport.createReport.groupBy.tooltip'
                                      | translate
                                  "
                                  class="d-flex align-items-center"
                                >
                                  <mat-icon class="icon-compact text-secondary"
                                    >info</mat-icon
                                  >
                        </span>
                      </div>
                    </div>
                  </div>
                        </div>
                      </div>
                      <!-- Chips -->
                      <div
                        class="col-12 mt-2"
                        *ngIf="reqform['index']?.length > 0"
                      >
                        <div class="d-flex flex-wrap gap-1">
                          <button
                            *ngFor="let e of reqform['index']"
                            (click)="removeFormField('index', e)"
                            type="button"
                            class="btn btn-outline-secondary btn-sm me-1 p-1 mb-1"
                          >
                      {{ e }}
                      <i class="fa fa-times ms-1 fs-6"></i>
                    </button>
                  </div>
                </div>
              </div>
                  </div>
                </div>

                <!-- Type and Show Total Section -->
                <div class="row g-2 align-items-center mb-3">
                  <div class="col-12">
                    <div class="row align-items-center">
                      <div
                        class="col-xl-2 col-lg-3 col-md-4 col-12 mb-md-0 mb-2"
                      >
                        <label class="fw-medium mb-0 text-nowrap">
                          {{
                            "customReport.createReport.type.label" | translate
                          }}
                    </label>
                      </div>
                      <div
                        class="col-xl-4 col-lg-5 col-md-8 col-12 mb-md-0 mb-2"
                      >
                        <div class="d-flex align-items-center gap-1">
                          <mat-form-field
                            appearance="outline"
                            class="no-bottom-margin w-100"
                          >
                            <mat-select
                              [(ngModel)]="reqform['chart_type']"
                              name="chartType"
                            >
                              <mat-option value="html">{{
                                "customReport.createReport.type.options.html"
                                  | translate
                              }}</mat-option>
                              <mat-option value="bar">{{
                                "customReport.createReport.type.options.bar"
                                  | translate
                              }}</mat-option>
                              <mat-option value="line">{{
                                "customReport.createReport.type.options.line"
                                  | translate
                              }}</mat-option>
                              <mat-option value="area">{{
                                "customReport.createReport.type.options.area"
                                  | translate
                              }}</mat-option>
                              <mat-option value="pie">{{"customReport.createReport.type.options.pie"
                              | translate
                              }}
                                </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <span
                            [title]="
                              'customReport.createReport.type.tooltip'
                                | translate
                            "
                            class="d-flex align-items-center"
                          >
                            <mat-icon class="icon-compact text-secondary"
                              >info</mat-icon
                            >
                    </span>
                  </div>
                </div>
                      <!-- Show Total -->
                      <div class="col-xl-6 col-lg-4 col-md-12 mt-3 mt-sm-auto">
                        <div class="row g-2 align-items-center">
                          <div class="col-auto">
                            <mat-checkbox
                              [(ngModel)]="reqform['margins']"
                              name="showtotal"
                              color="primary"
                            >
                              <span class="fw-medium">{{
                                "customReport.createReport.showTotal.label"
                                  | translate
                              }}</span>
                            </mat-checkbox>
                          </div>
                          <div class="col-auto">
                            <span
                              [title]="
                                'customReport.createReport.showTotal.tooltip'
                                  | translate
                              "
                              class="d-flex align-items-center text-secondary"
                            >
                              <mat-icon class="icon-compact">info</mat-icon>
                    </span>
                  </div>
                </div>
              </div>
                    </div>
                  </div>
                </div>

                <!-- Action Buttons Section -->
                <div class="row g-3 align-items-center mt-sm-3">
                  <div class="col-12">
                    <div class="d-flex flex-wrap align-items-center gap-2">
                      <button
                        mat-stroked-button
                        color="primary"
                        (click)="searchAndDraw(true)"
                      >
                        <mat-icon>directions</mat-icon>
                        <span>{{
                          "customReport.buttons.get" | translate
                        }}</span>
                </button>
                      <button
                        mat-stroked-button
                        color="primary"
                        (click)="resetSearchValues(); resetreportform()"
                        class="pdf-exclude"
                      >
                  <i class="fa fa-eraser"></i>
                        <span class="ms-2">{{
                          "customReport.buttons.refresh" | translate
                        }}</span>
                </button>
              </div>
            </div>
                </div>
              </div>
          </form>

            <!-- Report Display Area -->
            <div>
            <p *ngIf="form['error'] == false && form['message']">
              <app-ncs-alert
                [message]="form['message']"
                type="success"
                showAlert="true"
              />
            </p>
            <p *ngIf="form['error'] == true && form['message']">
              <app-ncs-alert
                [message]="form['message']"
                type="danger"
                showAlert="true"
              />
            </p>
            <div *ngIf="loading">loading ...</div>
            <div *ngIf="!loading">
                <!-- <div [innerHTML]="pivottable" class="table-responsive"></div>
                <img [src]="pivotUrl" width="100%" /> -->
                <!--  Table -->
                <div
                  *ngIf="pivottable"
                  [innerHTML]="pivottable"
                  class="table-responsive sticky-bordered-table"
                ></div>
                <!--  Plotly Chart -->
                <iframe
                  *ngIf="chartUrl"
                  [src]="chartUrl"
                  width="100%"
                  height="600px"
                  style="border: none"
                >
                </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

<!-- Add Report Modal -->
<div
  class="modal fade"
  id="staticBackdrop"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">
          {{ "customReport.addReportModal.title" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p *ngIf="reportform['error'] == false && reportform['message']">
          <app-ncs-alert [message]="reportform['message']" type="success" />
        </p>
        <p *ngIf="reportform['error'] == true && reportform['message']">
          <app-ncs-alert [message]="reportform['message']" type="danger" />
        </p>

        <!-- Title -->
        <div class="row mb-3">
          <label for="title" class="col-sm-3 col-form-label">
            {{ "customReport.addReportModal.labels.title" | translate }}
          </label>
          <div class="col-sm-9">
            <input
              (input)="checkReportLabel($event)"
              id="title"
              name="title"
              [placeholder]="
                'customReport.addReportModal.placeholders.title' | translate
              "
              type="text"
              class="form-control form-control-sm"
              required
              [(ngModel)]="reportform.data['title']"
            />
            <span style="color: red">{{ form.inputerror["title"] }} </span>
          </div>
        </div>

        <!-- Subtitle -->
        <div class="row mb-3">
          <label for="subTitle" class="col-sm-3 col-form-label">
            {{ "customReport.addReportModal.labels.subTitle" | translate }}
          </label>
          <div class="col-sm-9">
            <input
              id="subTitle"
              name="subTitle"
              [placeholder]="
                'customReport.addReportModal.placeholders.subTitle' | translate
              "
              type="text"
              class="form-control form-control-sm"
              required
              [(ngModel)]="reportform.data['subTitle']"
            />
            <span style="color: red">{{ form.inputerror["subTitle"] }} </span>
          </div>
        </div>

        <!-- Description -->
        <div class="row mb-3">
          <label for="description" class="col-sm-3 col-form-label">
            {{ "customReport.addReportModal.labels.description" | translate }}
          </label>
          <div class="col-sm-9">
            <textarea
              id="description"
              name="description"
              [placeholder]="
                'customReport.addReportModal.placeholders.description'
                  | translate
              "
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="reportform.data['description']"
            >
            </textarea>
            <span style="color: red">{{ form.inputerror["description"] }}</span>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          (click)="saveReport()"
        >
          <i class="fa fa-save"></i>
          {{ "customReport.buttons.save" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          data-bs-dismiss="modal"
        >
          <i class="fa fa-window-close"></i>
          {{ "customReport.buttons.close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Info / Guidelines Modal -->
<div
  class="modal fade"
  id="info"
  tabindex="-1"
  aria-labelledby="infoLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="h4 modal-title fs-5" id="infoLabel">
          {{ "GUIDELINES.TITLE" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div>
          <div class="mb-4">
            <h6 class="mb-2">
              <span class="badge bg-secondary rounded-pill me-2">1</span>
              {{ "GUIDELINES.SELECTING_ROWS" | translate }}
            </h6>
            <p class="text-secondary ms-4 ps-1">
              {{ "GUIDELINES.ROWS_DESCRIPTION" | translate }}
            </p>
          </div>
          <div class="mb-4">
            <h6 class="mb-2">
              <span class="badge bg-secondary rounded-pill me-2">2</span>
              {{ "GUIDELINES.SELECTING_COLUMNS" | translate }}
            </h6>
            <p class="text-secondary ms-4 ps-1">
              {{ "GUIDELINES.COLUMNS_DESCRIPTION" | translate }}
            </p>
          </div>
          <div class="mb-4">
            <h6 class="mb-2">
              <span class="badge bg-secondary rounded-pill me-2">3</span>
              {{ "GUIDELINES.SELECTING_VALUES" | translate }}
            </h6>
            <p class="text-secondary ms-4 ps-1">
              {{ "GUIDELINES.VALUES_DESCRIPTION" | translate }}
            </p>
          </div>
          <div class="mb-4">
            <h6 class="mb-2">
              <span class="badge bg-secondary rounded-pill me-2">4</span>
              {{ "GUIDELINES.SELECTING_FILTERS" | translate }}
            </h6>
            <p class="text-secondary ms-4 ps-1">
              {{ "GUIDELINES.FILTERS_DESCRIPTION" | translate }}
            </p>
          </div>
          <div class="mb-4">
            <h6 class="mb-3">
              <span class="badge bg-secondary rounded-pill me-2">5</span>
              {{ "GUIDELINES.AGGREGATION_FUNCTIONS" | translate }}
            </h6>
            <ul class="list-group list-group-flush bg-transparent ms-4">
              <li class="list-group-item bg-transparent border-0 py-1">
                <i class="fas fa-calculator text-primary me-2 fa-fw"></i>
                <b>{{ "GUIDELINES.SUM" | translate }}</b> -
                <span class="text-secondary">{{
                  "GUIDELINES.SUM_DESC" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <i class="fas fa-hashtag text-primary me-2 fa-fw"></i>
                <b>{{ "GUIDELINES.COUNT" | translate }}</b> -
                <span class="text-secondary">{{
                  "GUIDELINES.COUNT_DESC" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <i class="fas fa-chart-line text-primary me-2 fa-fw"></i>
                <b>{{ "GUIDELINES.AVERAGE" | translate }}</b> -
                <span class="text-secondary">{{
                  "GUIDELINES.AVERAGE_DESC" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <i class="fas fa-arrows-alt-v text-primary me-2 fa-fw"></i>
                <b>{{ "GUIDELINES.MAX_MIN" | translate }}</b> -
                <span class="text-secondary">{{
                  "GUIDELINES.MAX_MIN_DESC" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <i class="fas fa-percent text-primary me-2 fa-fw"></i>
                <b>{{ "GUIDELINES.PERCENT_TOTAL" | translate }}</b> -
                <span class="text-secondary">{{
                  "GUIDELINES.PERCENT_TOTAL_DESC" | translate
                }}</span>
              </li>
          </ul>
          </div>
          <div class="mt-4">
            <h5 class="mb-3">{{ "GUIDELINES.EXAMPLE_TITLE" | translate }}</h5>
            <div class="table-container">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
            <tr>
                      <th>{{ "GUIDELINES.EXAMPLE_REGION" | translate }}</th>
                      <th class="text-end">
                        {{ "GUIDELINES.EXAMPLE_RETAIL" | translate }}
                      </th>
                      <th class="text-end">
                        {{ "GUIDELINES.EXAMPLE_WHOLESALE" | translate }}
                      </th>
                      <th class="text-end">
                        {{ "GUIDELINES.EXAMPLE_TOTAL" | translate }}
                      </th>
            </tr>
                  </thead>
                  <tbody>
            <tr>
                      <td>
                        <span class="fw-semibold">{{
                          "GUIDELINES.EXAMPLE_NORTH" | translate
                        }}</span>
                      </td>
                      <td class="text-end">$10,000</td>
                      <td class="text-end">$15,000</td>
                      <td class="text-end fw-bold">$25,000</td>
            </tr>
            <tr>
                      <td>
                        <span class="fw-semibold">{{
                          "GUIDELINES.EXAMPLE_SOUTH" | translate
                        }}</span>
                      </td>
                      <td class="text-end">$8,000</td>
                      <td class="text-end">$12,000</td>
                      <td class="text-end fw-bold">$20,000</td>
            </tr>
            <tr>
                      <td>
                        <span class="fw-semibold">{{
                          "GUIDELINES.EXAMPLE_EAST" | translate
                        }}</span>
                      </td>
                      <td class="text-end">$5,000</td>
                      <td class="text-end">$10,000</td>
                      <td class="text-end fw-bold">$15,000</td>
            </tr>
                  </tbody>
          </table>
        </div>
      </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          type="button"
          color="warn"
          data-bs-dismiss="modal"
          [title]="'BUTTONS.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
